'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _radium = require('radium');

var _reactRedux = require('react-redux');

var _WMCompanyPage = require('./components/WMCompanyPage');

var _WMCompanyPage2 = _interopRequireDefault(_WMCompanyPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WMCompanyPagesSPA = function WMCompanyPagesSPA(_ref) {
	var companyNumber = _ref.companyNumber,
	    csrf = _ref.csrf,
	    compact = _ref.compact,
	    isPublic = _ref.isPublic,
	    store = _ref.store;

	return _react2.default.createElement(
		_radium.StyleRoot,
		null,
		_react2.default.createElement(
			_reactRedux.Provider,
			{ store: store },
			_react2.default.createElement(_WMCompanyPage2.default, {
				companyNumber: companyNumber,
				csrf: csrf,
				compact: compact,
				isPublic: isPublic
			})
		)
	);
};

var _default = WMCompanyPagesSPA;
exports.default = _default;


WMCompanyPagesSPA.propTypes = {
	companyNumber: _propTypes.PropTypes.string.isRequired,
	csrf: _propTypes.PropTypes.string.isRequired,
	compact: _propTypes.PropTypes.bool,
	isPublic: _propTypes.PropTypes.bool,
	store: _propTypes.PropTypes.object.isRequired // eslint-disable-line
};

WMCompanyPagesSPA.defaultProps = {
	isPublic: false,
	compact: false
};
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(WMCompanyPagesSPA, 'WMCompanyPagesSPA', 'src/WMCompanyPagesSPA.dev.js');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/WMCompanyPagesSPA.dev.js');
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/@workmarket/wm-company-pages-spa/build/WMCompanyPagesSPA.dev.js
// module id = u7ui
// module chunks = 62 63